<kendo-dialog *ngIf="dialogOpened" (close)="close()" [width]="850">
    <kendo-dialog-titlebar>
        <h3>{{ 'EXPORT-ASSESSMENTS' | translate }}</h3>
    </kendo-dialog-titlebar>
    <form novalidate [formGroup]="exportForm" class="k-form">
        <div class="row">
            <div class="col">
                <label class="k-form-field">
                    <span class="k-text-uppercase dark">{{'NAME' | translate}}
                    </span>
                    <input kendoTextBox formControlName="assessmentName" class="w-100" />
                </label>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label class="k-form-field">
                    <span class="k-text-uppercase dark">{{'ASSESSMENT-VERSIONS' | translate}} *
                    </span>
                    <kendo-multiselect [data]="listAssessmentVersions" formControlName="versions" [autoClose]="true"
                        [valuePrimitive]="true">
                    </kendo-multiselect>
                    <div class="k-tooltip k-tooltip-validation" role="alert"
                        *ngIf="versions.invalid && versions.touched">
                        {{'ASSESSMENT-VERSIONS-REQUIRED' | translate}}
                    </div>
                </label>
            </div>
        </div>
        <div class="row">
            <div class="col-6">
                <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                        {{'START-DATE' | translate}} *
                    </span>
                    <kendo-datetimepicker class="w-100" formControlName="start"></kendo-datetimepicker>
                </label>
            </div>
            <div class="col-6">
                <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                        {{'END-DATE' | translate}} *
                    </span>
                    <kendo-datetimepicker class="w-100" formControlName="end" [max]="maxDate"></kendo-datetimepicker>
                </label>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                        {{'EXPORT-FORMAT' | translate}} *
                    </span>
                    <kendo-combobox id="format" [data]="exportFormats" [valueField]="'value'" [textField]="'text'"
                        formControlName="format" class="w-100" [valuePrimitive]="true"
                        (valueChange)="formatChange($event)">
                    </kendo-combobox>
                    <div class="k-tooltip k-tooltip-validation" role="alert" *ngIf="format.invalid && format.touched">
                        {{'ASSESSMENT-FORMAT-REQUIRED' | translate}}
                    </div>
                </label>
            </div>
        </div>
        <div class="row" *ngIf="format.value !== '2'">
            <div class="col-12">
                <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                        {{'EXPORT-SELECTED-COLUMNS' | translate}}
                    </span>
                    <kendo-multiselect [checkboxes]="true" [autoClose]="true" [data]="columns"
                        formControlName="exportColumns" (valueChange)="columnsChange($event)">
                    </kendo-multiselect>
                </label>
            </div>
        </div>
        <div class="row" *ngIf="format.value === '2'">
            <div class="col-6">
                <label class="k-form-field">
                    <span class="k-text-uppercase dark">{{'PROVIDER-ID' | translate}} *
                    </span>
                    <input kendoTextBox formControlName="externalProviderId" class="w-100" />
                    <div class="k-tooltip k-tooltip-validation" role="alert"
                        *ngIf="externalProviderId.invalid && externalProviderId.touched">
                        {{'PROVIDER-ID-REQUIRED' | translate}}
                    </div>
                </label>
            </div>
            <div class="col-6">
                <label class="k-form-field">
                    <span class="k-text-uppercase dark">{{'ASSESSMENT-ID' | translate}} *
                    </span>
                    <input kendoTextBox formControlName="externalAssessmentId" class="w-100" />
                    <div class="k-tooltip k-tooltip-validation" role="alert"
                        *ngIf="externalAssessmentId.invalid && externalAssessmentId.touched">
                        {{'ASSESSMENT-ID-REQUIRED' | translate}}
                    </div>
                </label>
            </div>
        </div>
        <div class="row">
            <div class="col-6">
                <label class="k-form-field">
                    <span class="k-text-uppercase dark">{{'ASSESSMENT-EXPORT-DEFAULT-EMPTY-VALUE' | translate}}
                    </span>
                    <input kendoTextBox formControlName="exportDefaultEmptyValue" class="w-100"
                        (change)="defaultEmptyValueChange()" />
                </label>
            </div>
            <div class="col-6 mt-2">
                <app-advanced-mode id="exportLabelForAnswer" [storageKey]="'assessment-export-label-for-answer'"
                    [titleKey]="'ASSESSMENT-EXPORT-LABEL-FOR-ANSWER'"
                    (collapsibleToggle)="exportLabelForAnswer.setValue($event)">
                </app-advanced-mode>
            </div>
        </div>
        <div class="row mt-2">
            <div class="col-6">
                <app-advanced-mode id="exportLookups" [storageKey]="'assessment-export-lookups'"
                    [titleKey]="'EXPORT-ASSESSMENTS-LOOKUP'" (collapsibleToggle)="exportLookup.setValue($event)">
                </app-advanced-mode>
            </div>
            <div class="col-6">
                <app-advanced-mode id="closeAfterExport" [storageKey]="'assessment-export-close-after-export'"
                    [titleKey]="'EXPORT-CLOSE-MODAL-AFTER-EXPORT'"
                    (collapsibleToggle)="closeAfterExport.setValue($event)">
                </app-advanced-mode>
            </div>
        </div>
    </form>
    <div>* {{'REQUIRED-FIELDS' | translate}}</div>
    <kendo-dialog-actions>
        <button class="k-button k-primary" [disabled]="!exportForm.valid || !exportForm.dirty" (click)="onExport()">
            {{'EXPORT' | translate }}
        </button>
        <button class="k-button" (click)="close()">{{ 'CLOSE' | translate }}</button>
    </kendo-dialog-actions>
</kendo-dialog>